// extracted by mini-css-extract-plugin
export default {"root":"loadingFallback_root__xIfx7"};